import gql from 'graphql-tag';

const GetUser = gql`
  query getUser {
    user @client {
      __typename
      userId
      loggedIn
      email
      phone
    }
  }
`;

const UpdateUser = gql`
  mutation updateUser($userId: Int!, $loggedIn: Boolean!, $email: String!, $phone: String!) {
    updateUser(userId: $userId, loggedIn: $loggedIn, email: $email, phone: $phone) @client {
      __typename
      userId
      loggedIn
      email
      phone
    }
  }
`;

export { GetUser, UpdateUser };



// WEBPACK FOOTER //
// ./src/queries/user.tsx